























































import Mixin from 'common/mixin'
import LoginLayout from "components/login-layout.vue";
import { Logger } from "common/api.service";

import ApiHelper from 'common/api-helper';
import DateTimeHelperMixin from 'common/datetime-helper-mixin'
import store from 'store/login.store';

import Vue from "vue"
export default Vue.extend({
    name: 'login-input-password',

    data() {
        return {
            daigakuName: '旭川市立大学',
            username: '',
            password: '',
            validation: {
                loginResult: "",
            }
        };
    },

    /**
     * このコンポーネントを描画するルートが確立する前に呼ばれる処理
     * this でのこのコンポーネントへのアクセスはできません。
     */
    beforeRouteEnter(to, from, next) {
        next();
    },

    /**
     * このコンポーネントがエレメントにマウントされたときに呼ばれる処理
     */
    mounted() {
        const now = this.formatDate(new Date(), "yyyyMMdd")
        console.log(now);
        if (now < '20230401') {
            this.daigakuName = '旭川大学'
        }
    },

    computed: {
    },

    methods: {

        onSubmit(ev) {
            if (ev) {
                ev.preventDefault();
                Logger.logDebug(ev);
            }
        },

        async checkForm() {
            this.validation.loginResult = '';

            const http = ApiHelper.getNoAuthHttpWithoutBaseUrl();
            const params = new URLSearchParams();
            params.append('UserName', this.username);
            params.append('Password', this.password);
            params.append('RememberMe', 'true');

            try {
                const res = await http.post('/Account/ApiLogin', params);
                // 認証に成功
                if (res.status == 200) {
                    if (res.data) {

                    }
                    // if (window.PasswordCredential) {
                    //     const passwordCredential = new PasswordCredential({
                    //        id: this.username,
                    //        password: this.password
                    //        });
                    //     navigator.credentials.store(passwordCredential);
                    // }
                    Logger.logDebug(res);

                    if (location.search) {
                        // search : "?ReturnUrl=%2FHome%2FJump%3Faaa%3Dccc"
                        const params = new URLSearchParams(location.search);
                        const returnUrl = params.get('ReturnUrl');
                        if (returnUrl.startsWith('/Jump')) {
                            try {
                                const url = new URL(location.origin + returnUrl)
                                const redirectParams = new URLSearchParams(url.search);
                                const controller = redirectParams.get('Controller');
                                const action = redirectParams.get('Action');
                                const fragment = redirectParams.get('Fragment');
                                const redirectUrl = '/' + (controller ? controller : '')
                                    + (action ? '/' + action : '')
                                    + (fragment ? '#' + fragment : '')

                                window.location.href = redirectUrl;
                                return;
                            }
                            catch (e) {
                                Logger.logDebug(e);
                            }
                        }
                    }
                    window.location.href = '/';
                    return;
                }
            } catch (e) {
                this.validation.loginResult = 'ユーザー名またはパスワードが間違っています。';
            }

            event.preventDefault()
        },
    },

    mixins: [Mixin, DateTimeHelperMixin],
    components: { LoginLayout },
})
